export default "/images/coopforsikringer.avif?bb376bc0d3d105945ed2a79ed55c0315";